import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MapGoogleService } from 'src/app/services/map-google.service';
import { ToastService } from 'src/app/services/toast.service';
import { FilterOptionsEnum } from 'src/enumerators/filter-options.enum';
import { FilterOption } from '../filter-modal/filter-modal.component';

import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';

@Component({
  selector: 'app-multiple-select',
  templateUrl: './multiple-select.component.html',
  styleUrls: ['./multiple-select.component.css']
})
export class MultipleSelectComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() option: FilterOption;
  @Input() name: FilterOptionsEnum;
  @Input() searchMap: boolean; // Váriavel que verifica se é o input de pesquisa do mapa
  @Output() emitSelected = new EventEmitter<Array<any>>;

  @ViewChild('multiDropdownContainer', { static: false, read: ElementRef }) multiDropdownContainer: ElementRef<HTMLDivElement>;

  @ViewChild('multiDropdown', { static: false }) multiDropdown?: BsDropdownDirective;


  dropdownWidth = 0;

  lastSelected: any = '';
  selectedList: any[] = [];
  countPlus = 0;

  // Variáveis para select de endereço
  inputFilterSearch = ''; // Texto da pesquisa
  filterSearch: any[] = []; // Lista de filtros
  textInputValue = '';

  constructor(
    private _mapGoogleService: MapGoogleService,
    private _toastService: ToastService,
    private _localeService: BsLocaleService,
  ) { }

  ngOnInit(): void {
    this.syncSelectedListFromOption();
    this._localeService.use('pt-br');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.option && !changes.option.firstChange) {
      this.syncSelectedListFromOption();
    }
  }

  ngAfterViewInit(): void {
    this.updateDropdownWidth();

    if (this.multiDropdown) {
      this.multiDropdown.onShown.subscribe(() => {
        this.updateDropdownWidth();
      });
    }
  }

  private updateDropdownWidth(): void {
    if (this.multiDropdownContainer?.nativeElement) {
      const rect = this.multiDropdownContainer.nativeElement.getBoundingClientRect();
      this.dropdownWidth = rect.width;
    }
  }

  private syncSelectedListFromOption() {
    this.selectedList = this.normalizeIncomingSelected(this.option?.selected);
    this.lastSelected = this.selectedList.length ? this.selectedList[this.selectedList.length - 1] : '';

    setTimeout(() => {
      this.calcLenSelect();
    }, 200);
  }

  private normalizeIncomingSelected(selected: any[] = []): any[] {
    if (!Array.isArray(selected)) {
      return [];
    }

    if (this.option?.type !== 'DATE') {
      return [...selected];
    }

    const dateRange = this.extractDateRange(selected);
    return dateRange.filter((value) => !!value);
  }

  private extractDateRange(selected: any[]): Date[] {
    const rawRange =
      Array.isArray(selected?.[0]) && selected[0].length
        ? selected[0]
        : selected;

    return rawRange
      .slice(0, 2)
      .map((value) => this.toDate(value))
      .filter((value): value is Date => !!value);
  }

  private toDate(value: any): Date | undefined {
    if (!value) {
      return undefined;
    }

    if (value instanceof Date) {
      return new Date(value.getTime());
    }

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? undefined : parsedDate;
  }


  // Adiciona o item selecionado, a tag nova, na lista de selecionados; Only seria pros casos de só poder ter um valor selecionado
  addOptionFilter(value: any, only = false) {
    if (value === undefined || value === null) {
      return;
    }

    if (only) {
      // usado para intervalo de datas
      if (Array.isArray(value)) {
        this.selectedList = value;
      } else {
        this.selectedList = [value];
      }
    } else {
      if (Array.isArray(value)) {
        this.selectedList = [...value];
      } else {
        // evita duplicado
        if (!this.selectedList.includes(value)) {
          this.selectedList = [...this.selectedList, value];
        }
      }
    }

    setTimeout(() => {
      this.calcLenSelect();
    }, 200);

    this.lastSelected = value;
    this.sendSelectedList();
  }


  // Remove o teim selecionado, a tag some, na lista de selecionados;
  removeOptionFilter(id) {
    const i = this.selectedList.indexOf(id);
    if (i === -1) {
      return;
    }

    this.selectedList.splice(i, 1);
    if (!this.selectedList.length)
      this.lastSelected = '';
    else this.lastSelected = this.selectedList[this.selectedList.length - 1];

    setTimeout(() => {
      this.calcLenSelect();
    }, 200);

    this.sendSelectedList();
  }

  toggleOption(value: any) {
    if (this.selectedList.includes(value)) {
      this.removeOptionFilter(value);
    } else {
      this.addOptionFilter(value);
    }
  }


  // Calcula o tamanho do select para colocar o '+ N' ao final e esconder os que passam do tamanho
  calcLenSelect() {
    let sum = 0;
    let countPlus = 0;
    const selected = document.getElementById('select' + this.name);
    const tagSelected = document.getElementById('tags-selected' + this.name);

    if (tagSelected) {

      if (tagSelected.nodeName == 'DIV') {
        tagSelected.childNodes.forEach((child) => {
          if (child.nodeName == 'DIV' && child.textContent) {
            (child as HTMLElement).hidden = false;
            if (sum + (child as HTMLElement).offsetWidth + 16 < selected.offsetWidth * 0.90 && countPlus == 0) {
              sum = sum + (child as HTMLElement).offsetWidth + 16;
            } else {
              countPlus += 1;
              (child as HTMLElement).hidden = true;
            }
          }
        });
      }
    }
    this.countPlus = countPlus;
    this.sendSelectedList();
  }

  // Verifica se na lista de objetos tem algum objeto com certo ID e retorna o name dele;
  isValueKeyId(value): string {
    let name = '';
    this.option.optionList?.some((element) => {
      if (element.id == value) name = element?.name ?? element?.user?.firstName + ' ' + element?.user?.lastName;

    });
    return name || String(value);
  }

  addTextValues(rawValue?: string) {
    const values = this.parseTextValues(rawValue ?? this.textInputValue);
    if (!values.length) {
      return;
    }

    values.forEach((value) => this.addOptionFilter(value));
    this.textInputValue = '';
  }

  onTextInputKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      this.addTextValues();
    }
  }

  private parseTextValues(rawValue: string): string[] {
    const normalizedValue = (rawValue || '').trim();
    if (!normalizedValue) {
      return [];
    }

    if (normalizedValue.startsWith('[')) {
      try {
        const parsedValue = JSON.parse(normalizedValue);
        if (Array.isArray(parsedValue)) {
          return Array.from(
            new Set(
              parsedValue
                .map((value) => String(value).trim())
                .filter(Boolean),
            ),
          );
        }
      } catch (error) {
        // Fallback para split simples quando o texto não for um JSON válido.
      }
    }

    return Array.from(
      new Set(
        normalizedValue
          .split(/[\s,;\n\r\t]+/)
          .map((value) => value.trim())
          .filter(Boolean),
      ),
    );
  }

  // Funções para endereço do google
  // Definir Localização no Mapa com Base Na Escolha da Busca
  filterAddressSearch(result) {
    this.selectedList = [];
    this.inputFilterSearch = result?.name;
    this.selectedList.push(result)
    if (this.searchMap) this.sendResultGoogle(result)
    else this.sendSelectedList();

  }

  eraseFilterSearch() {
    this.inputFilterSearch = '';
    this.selectedList = [];
    this.filterSearch = [];
    this.sendSelectedList();
  }

  // Pesquisar pelo Google Map ou Open Street Map
  searchAddress(event) {
    this.filterSearch = [];
    const search = event.target.value || '';

    this._mapGoogleService.mapSearch(search, 'googleMaps').pipe(
      map((next: Array<any>) => {
        if (next['results']?.length === 0) {
          // Se o OpenStreetMap também não retornar resultados, mostra um aviso
          this._toastService.showError('Nenhum resultado encontrado.');
        }
        return next['results'].map(item => ({
          type: item.types[0],
          name: item.formatted_address,
          lat: item.geometry.location.lat,
          lng: item.geometry.location.lng,
        }));
      }),

      catchError(() => {
        // Em caso de falha no Google Maps ou resultado vazio, tenta o OpenStreetMap
        return this._mapGoogleService.mapSearch(search, 'openStreet').pipe(
          map((next: Array<any>) => {

            if (next?.length === 0) {
              // Se o Google Maps não retornar resultados, força a ir para o OpenStreet
              throw new Error('Nenhum resultado encontrado.');
            }
            return next.map(item => ({
              type: item.addresstype,
              name: item.display_name,
              lat: item.lat,
              lng: item.lon,
            }));
          }),

          catchError(() => {
            this._toastService.showError('Ocorreu um erro ao realizar a busca.');
            return of([]); // Finaliza o fluxo sem erro no console
          })
        );
      })

    ).subscribe(
      (next: Array<any>) => {
        if (next.length) {
          this.filterSearch = next;
        }
      }
    );
  }

  sendSelectedList() {
    this.emitSelected.emit(this.selectedList);
  }

  sendResultGoogle(result) {
    this.emitSelected.emit(result)
  }

  @HostListener('document:keydown.escape')
  onEscapePress() {
    if (this.multiDropdown && this.multiDropdown.isOpen) {
      this.multiDropdown.hide();
    }
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateDropdownWidth();
  }

}
